import BarChartIcon from '@mui/icons-material/BarChart'
import StadsprognoseList from './StadsprognoseList'
import StadsprognoseCreate from './StadsprognoseCreate'
import StadsprognoseShow from './StadsprognoseShow'

const resource = {
  list: StadsprognoseList,
  create: StadsprognoseCreate,
  show: StadsprognoseShow,
  icon: BarChartIcon,
}

export default resource
